// Priority service area cities (30) with full long-form copy (~2,000+ chars each)
// + supplemental stub cities with shorter templated copy.

export const COUNTIES = [
  {
    name: "Travis County / Central Austin",
    cities: [
      "austin",
      "downtown-austin",
      "south-austin",
      "north-austin",
      "east-austin",
      "west-austin",
      "northwest-austin",
      "southwest-austin",
      "bee-cave",
      "lakeway",
      "the-hills",
      "west-lake-hills",
      "rollingwood",
      "sunset-valley",
      "pflugerville",
      "manor",
      "lago-vista",
      "jonestown",
      "briarcliff",
      "volente",
      "hudson-bend",
      "wells-branch",
      "del-valle",
      "webberville",
    ],
  },
  {
    name: "Williamson County",
    cities: [
      "round-rock",
      "cedar-park",
      "georgetown",
      "leander",
      "liberty-hill",
      "hutto",
      "taylor",
      "jarrell",
      "weir",
      "granger",
      "florence",
      "thrall",
      "coupland",
      "brushy-creek",
      "anderson-mill",
      "serenada",
    ],
  },
  {
    name: "Hays County",
    cities: [
      "san-marcos",
      "kyle",
      "buda",
      "dripping-springs",
      "wimberley",
      "driftwood",
      "woodcreek",
      "mountain-city",
      "niederwald",
      "uhland",
      "henly",
      "hays",
      "bear-creek",
    ],
  },
  {
    name: "Bastrop County",
    cities: [
      "bastrop",
      "elgin",
      "smithville",
      "cedar-creek",
      "paige",
      "wyldwood",
      "camp-swift",
      "circle-d-kc-estates",
      "mcdade",
      "red-rock",
      "rosanky",
    ],
  },
  {
    name: "Caldwell County",
    cities: [
      "lockhart",
      "luling",
      "martindale",
      "maxwell",
      "dale",
      "prairie-lea",
      "mustang-ridge",
      "fentress",
      "stairtown",
    ],
  },
  {
    name: "Hill Country & Nearby",
    cities: [
      "marble-falls",
      "burnet",
      "bertram",
      "blanco",
      "johnson-city",
      "spicewood",
      "horseshoe-bay",
      "llano",
      "kingsland",
      "granite-shoals",
      "fredericksburg",
      "lampasas",
      "giddings",
      "la-grange",
    ],
  },
];

export function slugToCity(slug) {
  // Strip the -tx suffix if present so display names don't show "Austin Tx".
  const dataSlug = toDataSlug(slug);
  return dataSlug
    .split("-")
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join(" ");
}

// URL-form slug (canonical) appends the -tx state suffix:
//   "austin"        →  "austin-tx"
//   "round-rock"    →  "round-rock-tx"
// Use this whenever rendering /service-areas/<slug> links.
export function toUrlSlug(dataSlug) {
  if (!dataSlug) return dataSlug;
  return dataSlug.endsWith("-tx") ? dataSlug : `${dataSlug}-tx`;
}

// Reverse of the above — strips -tx so we can look up the data record in
// PRIORITY_CITY_DATA / ALL_CITY_SLUGS which are keyed by the bare slug.
export function toDataSlug(urlSlug) {
  if (!urlSlug) return urlSlug;
  return urlSlug.endsWith("-tx") ? urlSlug.slice(0, -3) : urlSlug;
}

// Slugs flagged as priority will get full long-form copy via PRIORITY_CITY_DATA.
export const PRIORITY_SLUGS = new Set([
  "austin",
  "downtown-austin",
  "south-austin",
  "north-austin",
  "east-austin",
  "west-austin",
  "pflugerville",
  "round-rock",
  "cedar-park",
  "georgetown",
  "leander",
  "liberty-hill",
  "hutto",
  "lakeway",
  "bee-cave",
  "west-lake-hills",
  "kyle",
  "buda",
  "san-marcos",
  "dripping-springs",
  "wimberley",
  "bastrop",
  "elgin",
  "lockhart",
  "luling",
  "manor",
  "taylor",
  "marble-falls",
  "spicewood",
  "driftwood",
]);

export const ALL_CITY_SLUGS = COUNTIES.flatMap((c) => c.cities);
